import { render, staticRenderFns } from "./login-failed.vue?vue&type=template&id=37bede65&"
import script from "./login-failed.vue?vue&type=script&lang=js&"
export * from "./login-failed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports